import axios from "../axios/Config"

export const TestService = {
    testConnectionBackend: function() {
        return axios.post("/test/connection");
    }
}